<template>
	<div class="page">
		<el-form label-position="left" :model="ruleForm" :rules="ruleData" ref="formRef" label-width="100px" class="demo-ruleForm">
			<el-form-item label="年份" prop="title">
        <el-date-picker 
					class="w400"
          v-model="ruleForm.title"
          type="year"
          placeholder="选择年份">
        </el-date-picker>
			</el-form-item>
			<el-form-item label="状态" prop="state">
        <el-radio-group :span="16" v-model="ruleForm.state">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
			</el-form-item>
			<el-form-item label="封面" prop="imageUrl" :error="uploadErrorInfo">
        <div class="fileBox">
          <draggable v-model="ruleForm.images" class="images">
              <div class="imageBox" v-for="(item,index) in ruleForm.images" :key="item">
                <el-image 
                  class="image"
                  :src="item" 
                  :preview-src-list="images">
                </el-image>
                <i class="el-icon-circle-close close cursor" @click="ruleForm.images.splice(index, 1)"></i>
              </div>
          </draggable>
          <wk-upload
            v-if="ruleForm.images.length<10"
            class="w400"
            accept=".png,.PNG,.jpg,.JPG,jpeg,JPEG,.webp,.WEBP,.gif,.GIF,.svg,.SVG"
            style="cursor: not-allowed;"
            :showProgrees="false"
            @uploadChange="handleImgChange"
            @uploadError="handleImgError"
          ></wk-upload>
        </div>
        <span class="grey">建议上传图片的尺寸比例为：480：418；最多上传10张；</span>
			</el-form-item>
			<el-form-item label="描述" prop="desc">
				<el-input
					class="w400"
					type="textarea"
					:rows="6"
					:maxlength="120"
					show-word-limit 
          v-model="ruleForm.desc" 
          placeholder="请输入描述内容">
        </el-input>
			</el-form-item>
			<div class="foot">
				<el-button class="w150" type="info" @click="cancel()">取消</el-button>
				<el-button class="w150" type="primary" @click="onSubmit()">发布</el-button>
			</div>
		</el-form>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
import store from '@/store/index.js';
export default {
    beforeRouteEnter: (to,from,next) => {
        store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': to.meta.menuBreadcrumb, name:to.query.id? "编辑活动":'添加活动', path: to.fullPath} );
        next()
    },
    components: {
      draggable,
    },
    data() {
        var validateImages = (rule, value, callback) => {
          if ( this.images > 0) {
            callback();
          }else {
            callback("请上传图片");
          }
        };
        return {
            uploadErrorInfo: '', // 上传的错误
            type: '',
            ruleForm: {
                id: '', 
                title: '', 
                state: '', 
                images:[], 
                desc: '',
            },
            ruleData: {
                title: [
                    {required: true, message: '请选择活动年份', trigger: ['change', 'blur']},
                ],
                state: [
                    {required: true, message: '请勾选状态', trigger: 'blur'}
                ],
                images: [
                    {validator: validateImages, message: '请上传图片', trigger: ['change', 'blur']},
                ],
            },
        }
    },
    computed: {
        userInfo() {
            return this.$store.getters["accountStore/getUserInfo"]; //获取用户信息
        }
    },
    created() {
        this.type = this.$route.query.type;
        if (this.type == 'edit'){
            this.loadData(this.$route.query.id)
        }
    },
    methods: {
        onDragStart(e) {
          // 如果是上传按钮，则阻止拖拽
          if (e.item._prevClass == 'w400') {
            console.log(11)
            e.preventDefault();
            return false;
          }
          
        },
        loadData(id) {
            this.$apis.activityServer.queryDetail({
                id: id
            }).then(res => {
                if (res['code'] == 0) {
                  res.data.title = new Date(res.data.title,1,1)
                  Object.assign(this.ruleForm, res.data)
                }
            })
        },
        handleImgChange(res) {
					this.uploadErrorInfo = ''
					if (res['code'] == 0) {
							this.ruleForm.images.push(res.data.link) 
					} else {
							this.uploadErrorInfo = result.message
					}
        },
        handleImgError(res) {
            console.log(res)
        },
        onSubmit() {
					this.$refs['formRef'].validate( async valid => {
						if (valid) {
							if (this.ruleForm.type == 2) {
									this.requestInfo()
							} else {
									this.requestInfo()
							}
						}
					})
        },
        // 资讯请求接口
        requestInfo() {
            let params = {
                id: this.ruleForm.id,
                title: this.ruleForm.title.getFullYear(), // 标题
                state: this.ruleForm.state,  // 状态:1、启用；2、停用
                images: this.ruleForm.images, // 缩略图
                desc: this.ruleForm.desc, // 描述
            }
            if (this.type == 'add') {
                this.$apis.activityServer.add(params).then(res => {
                    if (res['code'] == 0) {
                        this.$message.success('添加成功！')
                        this.close()
                    }
                })
            } else {
                this.$apis.activityServer.update(params).then(res => {
                    if (res['code'] == 0) {
                        this.$message.success('修改成功！')
                        this.close()
                    }
                })
            }
        },
        cancel() {
					const h = this.$createElement;
					this.$msgbox({
						title: '',
						message: h('p', null, [
										h('p', null, '确定取消吗？ '),
										h('p', null, '离开页面后已编辑的内容将会丢弃')
						]),

						showCancelButton: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						center: true
					}).then(() => {
							this.$router.back()
					})
        },
        close() {
					this.$refs['formRef'].resetFields();
          this.$router.push({ 
            path: '/activity/list', 
            query:{
              date: Date.now()
            }
          });
        }
    }
}
</script>
<style scoped lang="scss">
	.el-message-box--center .el-message-box__message {
		font-size: 20px;
		color: #000000;
	}

	.page {
		background-color: #fff;
		padding: 45px 100px;
		display: block;
		margin-top: 30px;
		border-radius: 10px;

	}
  .fileBox{
    display: flex;
    flex-wrap: wrap;
    .images{
      display: flex;
      flex-wrap: wrap;
      width: 1200px;
      margin-bottom: 10px;
      .imageBox{
        position: relative;
        border: 1px solid #DCDFE6;
        margin-right: 10px;
        margin-bottom: 10px;
        width: 178px;
        height: 178px;
        border-radius: 4px;
        overflow: hidden;
        .image{
          width: 100%;
          height: 100%;
        }
        .close{
          position: absolute;
          right: 2px;
          top: 2px;
          color:#DCDFE6 ;
          font-size: 18px;
        }
      }
    }
  }
	.foot {
		text-align: center;
	}

	.select-input {
		display: flex;
		margin-bottom: 30px;
	}

	.icon-img {
		width: 40px;
		height: 40px;
		// padding: 10px;
		margin-right: 10px;
		cursor: pointer;
		margin-left: 20px;
	}

	.w340 {
		width: 340px;
	}

	.w60 {
		width: 60px;
	}
</style>